// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".freemium-icon[data-v-61be3772]{display:flex;justify-content:center;align-items:center;width:100%;border-radius:16px;background-color:#fbc500;color:#000}.freemium-icon--sm[data-v-61be3772]{max-width:42px;height:42px}.freemium-icon--md[data-v-61be3772]{max-width:48px;height:48px}.freemium-icon--lg[data-v-61be3772]{max-width:56px;height:56px}", ""]);
// Exports
module.exports = exports;
